const serviceCreationBlockedModal = {
  title: 'Creación de servicio bloqueada',
  text: 'La creación de servicio solo está disponible escaneando el QRCODE del equipo en la App',
  okButton: 'Ok',
};

export default serviceCreationBlockedModal;
